import * as yup from 'yup'

export const ChangePasswordValidationScheme = yup.object().shape({
  password: yup
    .string()
    .max(256, 'Password has a maximum of 256 characters'),
  confirmPassword: yup
    .string()
    .when('password', (password, field) => (password
      ? field.required('The field is required').oneOf([yup.ref('password')], 'Passwords do not match')
      : field))
})
